import { PageContainer, useLinkedLocation } from "lqx-react";
import * as React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { appConfig } from "./api/appConfig";
import { NotAllowed } from "./components/not-allowed";
import { ConnectionsRouter } from "./connections/connections-routes";
import { CreditNotesPage } from "./creditnotes/credit-notes-page";
import { ImportJobsPage } from "./import-jobs/import-jobs-page";
import { ImportTemplatesRoutes } from "./import-templates/import-templates-routes";
import { IngestRouter } from "./ingest/ingest-router";
import { InsurancePoliciesPage } from "./insurancepolicies/insurcance-policies-page";
import { InvoicesRouter } from "./invoices/invoices-routes";
import { LinkPolicyPageRouter } from "./link";
import { DigitizationMenuRegistryInstance } from "./menu-registry";
import { DigitizationNavigationMenu } from "./navigation-menu";
import { NotificationSubscriptionsPage } from "./notification-subscriptions/notification-subscriptions-page";
import { PaymentsPage } from "./payments/payments-page";
import { RemittanceAdvicePage } from "./remittance-advice/remittance-advice-page";
import { ResolvePageRouter } from "./resolve";
import { UnappliedCashPage } from "./unapplied-cashes/unapplied-cashes-page";
import { ValidationRulesRouter } from "./validation-rules/validation-rules-routes";

export const SignalRContext = React.createContext(null);

export const DigitizationPageRouter = (props) => {
  appConfig.loadFrom(props.appConfig);
  const firstVisiblePath = DigitizationMenuRegistryInstance.getFirstVisibleMenuItemPath();
  const current = useLinkedLocation(2, firstVisiblePath);
  const notificationFunctions = React.useRef()

  return (
    <>
      {Can(UserEntitlementCatalogs.ViewAssetsGlobalTab) ?
        <SignalRContext.Provider value={{ notificationFunctions }}>
          <PageContainer
            menu={<DigitizationNavigationMenu />}
          >
            {
              current.value === 'ingest' ? <IngestRouter /> :
                current.value === 'resolve' ? <ResolvePageRouter /> :
                  current.value === 'insurancepolicies' && Can(UserEntitlementCatalogs.ViewVaultInsurancePoliciesTab) ? <InsurancePoliciesPage /> :
                    current.value === 'import-templates' ? <ImportTemplatesRoutes /> :
                      current.value === 'import-jobs' && Can(UserEntitlementCatalogs.ViewImportJobTab) ? <ImportJobsPage {...props.queryParams} /> :
                        current.value === 'invoices' ? <InvoicesRouter /> :
                          current.value === 'remittanceadvice' && Can(UserEntitlementCatalogs.ViewVaultRemittanceAdviceTab) ? <RemittanceAdvicePage /> :
                            current.value === 'unappliedCashes' && Can(UserEntitlementCatalogs.ViewVaultUnappliedCashTab) ? <UnappliedCashPage /> :
                              current.value === 'payments' && Can(UserEntitlementCatalogs.ViewVaultPaymentTab) ? <PaymentsPage /> :
                                current.value === 'creditNotes' && Can(UserEntitlementCatalogs.ViewVaultCreditNotesTab) ? <CreditNotesPage /> :
                                  current.value === 'linkPolicy' && Can(UserEntitlementCatalogs.LinkInvoices) ? <LinkPolicyPageRouter /> :
                                    current.value === 'notificationSubscriptions' && Can(UserEntitlementCatalogs.ViewManageSubscriptionsTab) ? <NotificationSubscriptionsPage /> :
                                      current.value === 'connections' ? <ConnectionsRouter /> :
                                        current.value === 'validation-rules' ? <ValidationRulesRouter /> :
                                        <NotAllowed />
            }
          </PageContainer>
        </SignalRContext.Provider>
        : <NotAllowed />}
    </>
  );
};

